import { ReportTagging } from 'gqlTypes'

export function getReportTypeTag(
  reportId: string,
  allTaggings: ReportTagging[]
) {
  const taggings = allTaggings.find((d) => d.reportId === reportId)
  if (taggings) {
    return taggings.tags.reportTypeTags.join(', ')
  }
  return ''
}

export function getYearTag(reportId: string, allTaggings: ReportTagging[]) {
  const taggings = allTaggings.find((d) => d.reportId === reportId)
  if (taggings) {
    return taggings.tags.yearTags.join(', ')
  }
  return ''
}
